import { RouteObject } from "react-router-dom";
import { MY_POSTS_PATH, MyPostsPage } from "@/modules/feed/pages/my-posts";
import {
  POSTS_MODERATION_PATH,
  PostsModerationPage,
} from "@/modules/feed/pages/posts-moderation";
import {
  POST_MODERATION_PATH,
  PostModerationPage,
} from "@/modules/feed/pages/post-moderation";

export const feedRoutes: RouteObject[] = [
  {
    path: MY_POSTS_PATH,
    element: <MyPostsPage />,
  },
  {
    path: POSTS_MODERATION_PATH,
    element: <PostsModerationPage />,
  },
  {
    path: POST_MODERATION_PATH,
    element: <PostModerationPage />,
  },
];
